document.addEventListener("click", (event) => {
    if (event) {
        quickViewATC(event);
    }
}, false);

function quickViewATC(event) {
    const element = event.target.id === "boost-pfs-quickview-cart-btn" || event.target.id === 'boost-pfs-quickview-cart-btn-text'; // add your element class/id/data-attr.
    if (element) {
        event.preventDefault();

        let formData = {
            items: [
                {
                    id: document.querySelector('#boost-pfs-quickview-variants-selector').value,
                    quantity: 1,
                },
            ],
        };

        theme.cart.addItemFromForm(formData).then(() => {
            theme.cart.getCart().then(function(cart) {
                theme.CartDrawer.prototype.status={
                    loaded: false,
                    loading: false
                };
                var source=$('#CartTemplate').html();
                theme.CartDrawer.prototype.template = Handlebars.compile(source);
                theme.CartDrawer.prototype.buildCart(cart);
                $('a.js-drawer-open-cart').click();
            });
        });
    }
}

$('.sticky-footer-nav').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    variableWidth: true,
    slidesToScroll: 3,
});

